import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

interface DateInputProps {
  value: any;
  onChange?: (newValue: any) => void;
  label: string;
  disabled?: boolean;
  mandatory?: boolean;
  warn?: boolean;
  warningText?: string;
  format?: string;
  /** Also pick the time of day (hours and minutes). */
  withTime?: boolean;
}

export default function DateInput({
  value,
  onChange,
  label,
  disabled,
  mandatory,
  warn,
  warningText,
  format,
  withTime,
}: DateInputProps) {
  return (
    <div style={{ position: "relative" }}>
      <div
        style={{
          position: "absolute",
          top: "-10px",
          left: "10px",
          width: "auto",
          color: "#808080",
          fontSize: 13,
          backgroundColor: "white",
          padding: "1px 4px",
          zIndex: 1,
        }}
      >
        {label} {mandatory && <span style={{ color: "red" }}>*</span>}
      </div>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        {withTime ? (
          <DateTimePicker
            className="w-100"
            value={value}
            onChange={onChange}
            format={format || "YYYY/MM/DD HH:mm"}
            ampm={false}
            disabled={disabled}
          />
        ) : (
          <DatePicker
            className="w-100"
            value={value}
            onChange={onChange}
            format={format || "YYYY/MM/DD"}
            disabled={disabled}
          />
        )}
      </LocalizationProvider>
      {warn && warningText && (
        <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>{warningText}</div>
      )}
    </div>
  );
}
